<span matSnackBarLabel data-testid="snackbar-label" [innerHTML]="configuration.data"></span>
<span matSnackBarActions>
  <button type="button" data-testid="snackbar-close-button" (click)="snackBarRef.dismissWithAction()" class="btn btn-icon-only"><svg-icon key="close" [size]="'sm'" /></button>
</span>
